import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecommendationCard = ({ recommendation }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate('/study-field-results');
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all duration-250 flex flex-col h-full">
      <div className="relative h-40 md:h-48 lg:h-56 overflow-hidden">
        <Image
          src={recommendation?.image}
          alt={recommendation?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 right-3">
          <div className="bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs md:text-sm font-medium">
            {recommendation?.matchScore}% Compatible
          </div>
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6 flex-1 flex flex-col">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name={recommendation?.icon} size={20} className="text-primary md:w-6 md:h-6" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-1 line-clamp-2">
              {recommendation?.title}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">{recommendation?.category}</p>
          </div>
        </div>
        
        <p className="text-sm md:text-base text-card-foreground mb-4 line-clamp-3 flex-1">
          {recommendation?.description}
        </p>
        
        <div className="flex flex-wrap gap-2 mb-4">
          {recommendation?.tags?.map((tag, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted text-muted-foreground rounded-md text-xs md:text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
        
        <Button
          variant="outline"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          onClick={handleViewDetails}
        >
          Voir les détails
        </Button>
      </div>
    </div>
  );
};

export default RecommendationCard;